import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Button,
  Label,
  Input,
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
} from "reactstrap";
import Breadcrumbs from "components/Common/Breadcrumb";
import CustomSelect from "components/Common/custom-select";
import TableContainer from "components/Common/TableContainer";
import { useLocation,useHistory } from "react-router-dom";
import getAccessRights from "components/Common/getAccessRights";
import { useDispatch, useSelector } from "react-redux";
import { useAuthUserDetails } from "components/Common/getAuthUserDetails";
import { exportEmployeeToExcel } from "pages/exports/exportExcel";
import { exportEmployeeToPDF } from "pages/exports/exportPDF";
import { fetchAgeWiseReport, fetchCategories, fetchDepartments, resetEmployeeReport } from "store/actions";
import { useFormik } from "formik";
import * as Yup from "yup";
import Loader from "common/pageLoader";

const EmployeeReportAgeWise = () => {
  const [accessRight, setAccessRight] = useState(null);
  const location = useLocation();
  const history = useHistory();
  useEffect(() => {
      const rights = getAccessRights(location.pathname, history);
      setAccessRight(rights?.data);
  }, [location]);
  const dispatch = useDispatch();
  const [authDetails, setAuthDetails] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const toggle = () => setDropdownOpen((prev) => !prev);
  const {
    employeeReport,
    categories,
    departments,
    loading,
    error,
    success
  } = useSelector((state) => ({
    employeeReport: state.EmployeeReportReducer?.employeeReport ?? [],
    categories: state.CategoryMaster?.categories ?? [],
    departments: state.DepartmentMaster?.departments ?? [],

    loading: state.EmployeeReportReducer?.loading,
    error: state.EmployeeReportReducer?.error,
    success: state.EmployeeReportReducer?.success,
  }));

  useEffect(() => {
    dispatch(resetEmployeeReport())
    const authUserDetails = useAuthUserDetails();
    setAuthDetails(authUserDetails[0])
    const unitId = authUserDetails[0].unit_id
    dispatch(fetchCategories(unitId));
    dispatch(fetchDepartments(unitId));
  }, [dispatch]);

  const formik = useFormik({
    initialValues: {
      category: "",
      department: "",
      empCode: "",
      empName: "",
      ageFilter: false,
      ageFrom: "",
      ageTo: "",
      ageType: "As onJoining"
    },

    validationSchema: Yup.object({
      ageFrom: Yup.string()
        .matches(/^[0-9]*$/, "Only numbers allowed")
        .max(2, "Max 2 digits"),
      
      ageTo: Yup.string()
        .matches(/^[0-9]*$/, "Only numbers allowed")
        .max(2, "Max 2 digits")
        .test(
          "age-range-check",
          "To age must be greater than From age",
          function (value) {
            const { ageFrom, ageFilter } = this.parent;
            if (!ageFilter || !ageFrom || !value) return true;
            return Number(value) >= Number(ageFrom);
          }
        ),
    }),

    onSubmit: (values) => {
      const formData = new FormData();

      formData.append("emp_cat", values.category || 0);
      formData.append("emp_dep", values.department || 0);
      formData.append("unit_id", authDetails?.unit_id);
      formData.append("create_by", authDetails?.user_id);
      // formData.append("empCode", values.empCode);
      // formData.append("empName", values.empName);

      // if (values.ageFilter) {
        formData.append("age_from", values.ageFrom || 0);
        formData.append("age_to", values.ageTo || 0);
        // formData.append("ageType", values.ageType);
      // }

      dispatch(fetchAgeWiseReport(formData));
    },
  });

  const handleReset = () => {
     formik.resetForm(); 
     dispatch(resetEmployeeReport()); 
  };

  const columns = [
    { Header: "S.No", Cell: ({ row }) => employeeReport.length - row.index, className: "serial-no text-center", applyHeaderClass: true },
    { Header: "Code", accessor: "emp_no" },
    { Header: "Name", accessor: "emp_name" },
    { Header: "Designation", accessor: "designation" },
    { Header: "Department", accessor: "dep_name" },
    { Header: "Category", accessor: "emp_category" },
    { Header: "DOB", accessor: "dob" },
    { Header: "Gender", accessor: "gender" },
    { Header: "Age", accessor: "asnow_age" },
    { Header: "Age Atjoining", accessor: "age_atjoining" },
    { Header: "Joined Date", accessor: "joined_dt" },
  ];

  return (
    <div className="page-content">
      <Loader loading={loading} />
      <Container fluid>
        <Breadcrumbs title="Employee" breadcrumbItem="Age Wise Search" />

        <Card>
          <CardBody>
            <form onSubmit={formik.handleSubmit}>
              <Row className="gy-3 align-items-end">
                <Col md={3}>
                  <Label>Category</Label>
                  <CustomSelect
                    id="category"
                    name="category"
                    options={categories.map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))}
                    value={
                      categories
                        .map(cat => ({ value: cat.empCatgryid, label: cat.empCategory }))
                        .find(cat => cat.value === formik.values.category) || null
                    }
                    onChange={val => formik.setFieldValue('category', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.category && formik.errors.category ? 'is-invalid' : ''}`}
                  />
                </Col>

                <Col md={3}>
                  <Label>Department</Label>
                  <CustomSelect
                    id="department"
                    name="department"
                    options={departments.map(dept => ({ value: dept.departmentId, label: dept.departmentname }))}
                    value={
                      departments
                        .map(dept => ({ value: dept.departmentId, label: dept.departmentname }))
                        .find(dept => dept.value === formik.values.department) || null
                    }
                    onChange={val => formik.setFieldValue('department', val ? val.value : '')}
                    onBlur={formik.handleBlur}
                    className={`select-dropdown ${formik.touched.department && formik.errors.department ? 'is-invalid' : ''}`}
                  />
                </Col>

                {/* <Col md={4}>
                  <Label>Employee Code</Label>
                  <Input
                    type="text"
                    name="empCode"
                    value={formData.empCode}
                    onChange={handleInputChange}
                  />
                </Col>

                <Col md={4}>
                  <Label>Employee Name</Label>
                  <Input
                    type="text"
                    name="empName"
                    value={formData.empName}
                    onChange={handleInputChange}
                  />
                </Col> */}                

                {/* <Col md={3}>
                  <Row className="align-items-center">
                    <Col className="d-flex" md="auto">
                      <Label className="mb-0">
                        <Input
                          type="radio"
                          name="ageType"
                          value="As onJoining"
                          checked={formik.values.ageType === "As onJoining"}
                          onChange={formik.handleChange}
                        />{" "}
                        As onJoining
                      </Label>
                    </Col>

                    <Col className="d-flex" md="auto">
                      <Label className="mb-0">
                        <Input
                          type="radio"
                          name="ageType"
                          value="As Now"
                          checked={formik.values.ageType === "As Now"}
                          onChange={formik.handleChange}
                        />{" "}
                        As Now
                      </Label>
                    </Col>
                  </Row>
                </Col> */}

                <Col md={3}>
                  <Row className="align-items-center">
                    <div className="col-md-3 mb-2 mb-md-0 d-flex align-items-center gap-2">
                      <Input
                        type="checkbox"
                        name="ageFilter"
                        checked={formik.values.ageFilter}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          formik.setFieldValue("ageFilter", checked);
                          if (!checked) {
                            formik.setFieldValue("ageFrom", "");
                            formik.setFieldValue("ageTo", "");
                          }
                        }}
                      />
                      <Label className="mb-0">Age</Label>
                    </div>

                    {formik.values.ageFilter && (
                      <div className="d-flex flex-wrap col-md-9 gap-2">
                        <Col md="5" className="col-12">
                          <Input
                            type="text"
                            name="ageFrom"
                            placeholder="From"
                            maxLength={2}
                            value={formik.values.ageFrom}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onKeyDown={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formik.touched.ageFrom && formik.errors.ageFrom && (
                            <div className="text-danger">
                              {formik.errors.ageFrom}
                            </div>
                          )}
                        </Col>

                        <Col md="5" className="col-12">
                          <Input
                            type="text"
                            name="ageTo"
                            placeholder="To"
                            maxLength={2}
                            value={formik.values.ageTo}
                            onChange={formik.handleChange}
                            onBlur={formik.handleBlur}
                            onKeyDown={(e) => {
                              if (!/[0-9]/.test(e.key) && e.key !== "Backspace" && e.key !== "Tab") {
                                e.preventDefault();
                              }
                            }}
                          />
                          {formik.touched.ageTo && formik.errors.ageTo && (
                            <div className="text-danger">
                              {formik.errors.ageTo}
                            </div>
                          )}
                        </Col>
                      </div>
                    )}
                  </Row>
                </Col>

                <Col className="d-flex mob-center align-items-center justify-content-end">
                  <Button type="submit" className="btn button-search me-2 mt-2">
                    <i className="fas fa-search me-1" /> Search
                  </Button>
                  <Button type="button" className="btn button-cancel me-2 mt-2" onClick={handleReset}>
                    <i className="fas fa-sync me-1" /> Cancel
                  </Button>
                  {/* <Button type="button" className="btn button-export me-2 mt-2">
                    <i className="fas fa-file-export me-1" /> Export
                  </Button>
                  <Button type="button" className="btn button-print mt-2">
                    <i className="fas fa-print me-1" /> Print
                  </Button> */}
                  {employeeReport && employeeReport.length > 0 && (
                    <Dropdown isOpen={dropdownOpen} toggle={toggle} direction="down">
                      <DropdownToggle color="primary" className="btn button-export mt-2">
                        <i className="fas fa-file-export me-1" /> Export
                      </DropdownToggle>

                      <DropdownMenu>
                        <DropdownItem onClick={() => exportEmployeeToExcel(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Employee AgeWise Report")}>
                          <i className="fas fa-file-excel me-2 text-success" /> Export to Excel
                        </DropdownItem>

                        <DropdownItem onClick={() => exportEmployeeToPDF(employeeReport, authDetails?.unit_fullname, authDetails?.unit_address, "Employee AgeWise Report", columns)}>
                          <i className="fas fa-file-pdf me-2 text-danger" /> Export to PDF
                        </DropdownItem>
                      </DropdownMenu>
                    </Dropdown>
                  )}   
                </Col>
              </Row>
            </form>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
              <TableContainer
                columns={columns}
                data={employeeReport}
                isGlobalFilter={true}
                customPageSize={10}
              />
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default EmployeeReportAgeWise;

